<div class="tabs_container_flightDetails" aria-live="assertive">
  <div class="tabsHeader">
    <div
      class="tab_base"
      [ngClass]="{'tab_select': selectedTab === TabType.FareDetails}"
      (click)="selectedTab = TabType.FareDetails"
      (keydown.enter)="selectedTab = TabType.FareDetails"
      tabindex="0"
      role="button"
      i18n="@@itemDetailsFaredetails"
    >
      Fare Details
    </div>
    <div
      class="tab_base"
      [ngClass]="{'tab_select': selectedTab === TabType.FlightLegTimes}"
      (keydown.enter)="selectedTab = TabType.FlightLegTimes"
      (click)="selectedTab = TabType.FlightLegTimes"
      tabindex="0"
      role="button"
      i18n="@@itemDetailsFlightLegTimes"
    >
      Show Details
    </div>
  </div>
  @if (selectedTab === TabType.FareDetails) {
  <div class="pane" id="0" i18n-Title title="Fare Details">
    <div class="ticketScroll">
      @if (debug) {
      <button (click)="alwaysLog(flightDetail)">Dump</button>
      } @for (ticket of tickets; track ticket) {
      <span hidden>{{ticket.title | translate}}</span>
      <app-flight-type-tickets-old
        class="economy"
        [tickets]="ticket.flights"
        [isSelected]="isSelected"
        [flightDetails]="flightDetail"
        [type]="ticket.type"
        [title]="ticket.title"
        [direction]="direction"
        [search]="search"
        [searchParams]="searchParams"
      >
      </app-flight-type-tickets-old>
      }
    </div>
  </div>
  } @if (selectedTab === TabType.FlightLegTimes) {
  <div class="pane" id="1">
    <div class="leg_wrapper">
      <div class="leg_container">
        <app-routehappy [flight]="flightDetails"></app-routehappy>
        <app-flight-legs-old [legs]="legs" [flight]="flightDetail"> </app-flight-legs-old>
      </div>
    </div>
  </div>
  }
</div>
